import { useCallback, useContext } from "react";
import ConfiguratorContext from "../../../../components/ConfiguratorContext";

const useSetResponsesPreviousValues = (activeStep) => {
  const { responses, setResponses } = useContext(ConfiguratorContext);
  return useCallback(() => {
    if (activeStep?.questions?.length) {
      setResponses({
        ...responses,
        ...activeStep.questions.reduce(
          (acc, question) => ({
            ...acc,
            ...(responses[question.id]
              ? {
                  [question.id]: {
                    ...responses[question.id],
                    ...(responses[question.id]?.savedValue
                      ? { value: responses[question.id]?.savedValue }
                      : {}),
                  },
                }
              : {}),
          }),
          {}
        ),
      });
    }
  }, [responses, activeStep, setResponses]);  // eslint-disable-line react-hooks/exhaustive-deps
};

export default useSetResponsesPreviousValues;
